import { FC } from 'react'

import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query'

import { Button, Cluster, Icon } from '@forto-dev/phoenix-ui-core/common'

import { useAuth } from '@/features/auth'
import { downloadBlob } from '@/utils/download'
import { useLocalisation } from '@/utils/localisation'

import { entityAllDocumentsDownloadQueryOptions, entityDocumentsQueryOptions } from '../api/useEntityDocuments'

export type DocumentsActionsProps = {
  id: string
  manualQuoteID?: string
  bookingID?: string
}

export const DocumentsActions: FC<DocumentsActionsProps> = ({ id, manualQuoteID, bookingID }) => {
  const { translate } = useLocalisation()
  const { user } = useAuth()
  const queryClient = useQueryClient()

  const documents = useSuspenseQuery(entityDocumentsQueryOptions(id, manualQuoteID, bookingID))
  const totalDocuments = documents.data.results.length

  if (totalDocuments === 0) {
    return null
  }

  return (
    <Button
      variant="outline-primary"
      onClick={async () => {
        const blob = await queryClient.fetchQuery(entityAllDocumentsDownloadQueryOptions(user?.customerId ?? '?', id))
        downloadBlob(blob, `${id}.zip`)
      }}
    >
      <Cluster gap={4} y="center">
        {translate('documents.downloadAll')} <Icon name="ArrowDown" size="xs" />
      </Cluster>
    </Button>
  )
}
